import { render, staticRenderFns } from "./ScoopQuestion.vue?vue&type=template&id=709b48b1&scoped=true&"
import script from "./ScoopQuestion.vue?vue&type=script&lang=js&"
export * from "./ScoopQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ScoopQuestion.vue?vue&type=style&index=0&id=709b48b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709b48b1",
  null
  
)

export default component.exports